import {
  NoConfirmationDefaultNavigatorConfiguration,
  NoConfirmationPreQualifiedCustomerNavigatorConfiguration
} from "../App/Compositions/NavigatorConfigurations";
import {
  noConfirmationStaticCenterBookingStepConfigurations,
  screeningStepConfigurations
} from "../App/Compositions/StepConfigurations";
import { Flow } from "./IFlow";

const rebookFlowName = "rebook";

/** Legacy flow name alias. Routes users with cached "rebook" sessions to the no-confirmation experience. */
class RebookFlow extends Flow {
  static readonly flowName = rebookFlowName;

  constructor(isCustomerPreQualified: boolean) {
    isCustomerPreQualified
      ? super(rebookFlowName, { ...noConfirmationStaticCenterBookingStepConfigurations }, [
          ...NoConfirmationPreQualifiedCustomerNavigatorConfiguration
        ])
      : super(
          rebookFlowName,
          { ...screeningStepConfigurations, ...noConfirmationStaticCenterBookingStepConfigurations },
          [...NoConfirmationDefaultNavigatorConfiguration]
        );
  }
}

export default RebookFlow;
